"use client";

import type { ReactNode } from "react";
import { CircleQuestionMark } from "lucide-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function HelpTip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            className={cn(
              "inline-flex shrink-0 cursor-help align-middle text-muted-foreground/70 transition-colors hover:text-foreground",
              className,
            )}
          />
        }
      >
        <CircleQuestionMark className="size-3.5" />
      </TooltipTrigger>
      <TooltipContent className="max-w-xs whitespace-pre-wrap text-left leading-relaxed">
        {children}
      </TooltipContent>
    </Tooltip>
  );
}
